import {
  columnVisibilityFeature,
  createExpandedRowModel,
  createTableHook,
  metaHelper,
  rowExpandingFeature,
  rowSelectionFeature,
  rowSortingFeature,
  tableFeatures,
} from '@tanstack/react-table';

import type {
  CellContext,
  Column,
  ColumnDef,
  RowData,
} from '@tanstack/react-table';

export type AppColumnMeta = {
  className?: string;
};

export const features = tableFeatures({
  rowSortingFeature,
  rowExpandingFeature,
  rowSelectionFeature,
  columnVisibilityFeature,
  expandedRowModel: createExpandedRowModel(),
  columnMeta: metaHelper<AppColumnMeta>(),
});

export type AppTableFeatures = typeof features;

export const { createAppColumnHelper, useAppTable } = createTableHook({
  features,
  getRowId: (row: object, index: number) => {
    const rowWithId = row as { id?: string | number };
    return rowWithId.id !== undefined ? String(rowWithId.id) : String(index);
  },
});

export type AppColumnDef<TData extends RowData, TValue = unknown> = ColumnDef<
  AppTableFeatures,
  TData,
  TValue
>;

export type AppColumn<TData extends RowData, TValue> = Column<
  AppTableFeatures,
  TData,
  TValue
>;

export type AppTableInstance<TData extends RowData> = ReturnType<
  typeof useAppTable<TData>
>;

export type AppCellContext<TData extends RowData> = Pick<
  CellContext<AppTableFeatures, TData, unknown>,
  'row' | 'getValue'
>;
